// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-simple-context-menu/dist/vue-simple-context-menu.css
// module id = 507
// module chunks = 1